import { BuiltInAttribute } from "@orsane/schema/tasks";
import { TitleCell } from "@/components/task-table/TitleCell";
import type { ColumnDef } from "../ColumnModel";
import type { Row } from "../RowModel";

export function buildTitleColumn(): ColumnDef {
    return {
        id: BuiltInAttribute.title,
        header: "Title",
        isVisible: true,
        cssColDef: "minmax(400px, auto)",
        isRight: false,
        isReadOnly: false,
        getSortValue: ({ row }: { row: Row }) => {
            return row.data.title;
        },
        getGroupHeader: ({ row }: { row: Row }) => {
            return row.data.title;
        },
        cell: ({ row }: { row: Row }) => {
            // title cell is memoized
            return <TitleCell task={row.data} />;
        },
    };
}
